var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingbox"},[_c('div',{staticClass:"loader_bg"},[_c('iframe',{attrs:{"src":`https://www.cruisereizen.nl/swimturtle`,"width":"100%","height":"200","frameborder":"0"}})]),_c('p',{staticStyle:{"margin-top":"-50px"}},[_vm._v(_vm._s(_vm.randomMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }